import { Icon } from "antd";
import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { remove_patient_on_schedules, remove_selected_patient_resource, resetStateResource } from "src/store/actions";
import SubSideNav from "../../common/components/SubSideNav";
import { collapseSideNav } from "../../store/actions";
import { setOblDateString } from "../../store/actions/datestring";
import MainContainer from "./ProcedureWorkflow";
class ClinicWorkFlow extends Component {
  sideNavLinks = [
    {
      link: "/obl-workflow/check-in",
      label: "Check-In",
    },
    {
      link: "/obl-workflow/obl",
      label: "OBL Module",
    },
  ];

  state = {
    isSideNav: true,
  };

  componentDidMount() {
    if (window.innerWidth <= 768) {
      this.closeSideNav();
    }
  }

  renderMetadata() {
    return (
      <Helmet>
        <title>FAACT Vascular | OBL Workflow</title>
        <meta name="title" content="FAACT Vascular | OBL Workflow" />
      </Helmet>
    );
  }

  openSideNav = () => {
    this.setState({ isSideNav: true });
    this.props.collapseSideNav(false);
  };

  closeSideNav = () => {
    this.setState({ isSideNav: false });
    this.props.collapseSideNav(true);
  };

  getTitle = () => (
    <div className="sub-title">
      <Icon type="key" />
      OBL Workflow
    </div>
  );

  onLinkClick = (link) => {
    // remove state reducer when click out
    this.props.remove_patient_on_schedules();
    this.props.remove_selected_patient_resource();
    this.props.resetStateResource();
    this.closeSideNav();
  };

  render() {
    const { location } = this.props;
    const { isSideNav } = this.state;
    return (
      <div className="clinicWorkflow">
        {this.renderMetadata()}
        <SubSideNav
          subMenu={this.sideNavLinks}
          title={this.getTitle()}
          isSideNav={isSideNav}
          openSideNav={this.openSideNav}
          closeSideNav={this.closeSideNav}
          onLinkClick={this.onLinkClick}
        />
        <MainContainer location={location} isSideNav={isSideNav} />
      </div>
    );
  }
}

const mapDispatchToProps = {
  collapseSideNav,
  setOblDateString,
  remove_patient_on_schedules,
  remove_selected_patient_resource,
  resetStateResource,
};

export default connect(null, mapDispatchToProps)(ClinicWorkFlow);
